export default "__VITE_ASSET__CSiEnvnL__"